<div clickOutside (clickOutside)="handleClickOutside()">
  <!--TWO INPUTS-->
  <div class="form-group date-picker" (click)="openDatePicker()" *ngIf="!withoutInputs && !singleInput">
    <div class="d-flex">
      <label for="dateRangeFrom" class="w-50">
        {{ labelFrom }}
        <span *ngIf="showRequierdAsterisk" class="ml-1 color-red">*</span>
      </label>
      <label for="dateRangeTo" class="w-50">
        {{ labelTo }}
        <span *ngIf="showRequierdAsterisk" class="ml-1 color-red">*</span>
      </label>
    </div>
    <div class="d-flex date-picker__input">
      <input
        type="text"
        class="form-control w-50"
        [ngClass]="{ isOpen: checkinClicked && isOpen }"
        placeholder="{{ placeholder }}"
        name="fromModel"
        value="{{ fromModel | date : dateFormat }}"
        id="dateRangeFrom"
        readonly
        [attr.data-qa]="testIdFrom"
      />
      <input
        type="text"
        class="form-control w-50"
        [ngClass]="{ isOpen: checkoutClicked && isOpen }"
        placeholder="{{ placeholder }}"
        name="toModel"
        value="{{ toModel | date : dateFormat }}"
        id="dateRangeTo"
        readonly
        [attr.data-qa]="testIdTo"
      />
    </div>
    <ng-content select="[rx-error]"></ng-content>
  </div>

  <!--SINGLE INPUT-->
  <div class="form-group date-picker" (click)="openDatePicker()" *ngIf="singleInput">
    <div class="d-flex">
      <label for="dateRangeFrom">{{ singleInputLabel }}</label>
    </div>
    <div class="d-flex date-picker__input">
      <input
        type="text"
        class="form-control"
        [ngClass]="{ isOpen: checkinClicked && isOpen }"
        placeholder="{{ placeholder }}"
        name="fromModel"
        value="{{ fromModel | date : dateFormat }} - {{ toModel | date : dateFormat }}"
        id="dateRangeFrom"
        readonly
      />
    </div>
    <ng-content select="[rx-error]"></ng-content>
  </div>

  <ng-container *ngIf="isOpen || withoutInputs">
    <ngb-datepicker
      #dp
      @collapseExpand
      [ngClass]="{
        'next-disabled': !navigationNextEnabled,
        'prev-disabled': !navigationPreviousEnabled,
        'without-inputs': withoutInputs
      }"
      (dateSelect)="onDateSelection($event)"
      [displayMonths]="2"
      [dayTemplate]="t"
      [navigation]="navigation"
      [outsideDays]="outsideDays"
      [minDate]="minDateNgbDate"
      [maxDate]="maxDateNgbDate"
      [startDate]="startDateNgbDate"
      [firstDayOfWeek]="firstDayOfWeek"
      (navigate)="onDateNavigation($event)"
    >
    </ngb-datepicker>
  </ng-container>

  <ng-template #t let-date let-focused="focused">
    <span
      class="cell"
      [class.focused]="focused"
      [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)"
      (mouseenter)="hoveredDate = date"
      (mouseleave)="hoveredDate = null"
    >
      {{ date.day }}
    </span>
  </ng-template>
</div>
